// extracted by mini-css-extract-plugin
module.exports = {"root":"EditNetworkForm_root__2vUPU","submit":"EditNetworkForm_submit__3nijV"};